module.exports = __webpack_public_path__ + "assets/a853b62657376f0f1a25fff859b3eec3.mp3";